module.exports = __webpack_public_path__ + "static/media/tezexbridge.e50305a5.png";